/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Regenerate_Instructions_P1Inputs */

const en_two_fa_regenerate_instructions_p1 = /** @type {(inputs: Two_Fa_Regenerate_Instructions_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have been asked to regenerate your two-factor authentication.`)
};

const nl_two_fa_regenerate_instructions_p1 = /** @type {(inputs: Two_Fa_Regenerate_Instructions_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bent gevraagd om je twee-factor-authenticatie opnieuw te genereren.`)
};

/**
* | output |
* | --- |
* | "You have been asked to regenerate your two-factor authentication." |
*
* @param {Two_Fa_Regenerate_Instructions_P1Inputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_regenerate_instructions_p1 = /** @type {((inputs?: Two_Fa_Regenerate_Instructions_P1Inputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Regenerate_Instructions_P1Inputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_regenerate_instructions_p1(inputs)
	return en_two_fa_regenerate_instructions_p1(inputs)
});